export default __webpack_public_path__ + "static/Bitrate_Test_11_WDRMODE_0_2560000-f1d1edd41bb21e4f9afb68950b11c8dc.avif";